const profile = (() => {
  const profile = process.env.REACT_APP_PROFILE || 'mithun';
  return require(`./${profile}`);
})();

export default profile.default || {};
